/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ServicedeskRovoEntrypointComponent = EntryPointComponent<
	Record<string, never>,
	Record<string, never>,
	{},
	Record<string, never>
>;

export const servicedeskRovoEntrypoint: EntryPoint<
	ServicedeskRovoEntrypointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<ServicedeskRovoEntrypointComponent>(
		/* webpackChunkName: "async-project-settings-service-desk-rovo", jiraSpaEntry: "async-project-settings-service-desk-rovo" */ './RovoView.tsx',
	),
	getPreloadProps: () => ({}),
});
